import {
  Component,
  OnInit,
  inject,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { SharedModule } from 'src/shared/shared.module';
import { MarketingWifiService, WifiStatusData } from 'src/shared/services/marketing-wifi.service';

@Component({
  selector: 'wifi-router-status-page',
  templateUrl: 'wifi-router-status.page.html',
  standalone: true,
  imports: [CommonModule, TidyUiComponentsModule, SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WifiRouterStatusPage implements OnInit {
  private readonly navCtrl = inject(CustomNavController);
  private readonly storage = inject(TidyStorage);
  private readonly wifiService = inject(MarketingWifiService);
  private readonly cdr = inject(ChangeDetectorRef);
  readonly windowService = inject(WindowService);

  wifiData: WifiStatusData | null = null;
  statusIcon = '';
  statusLabel = '';
  formattedLastPing = '';

  async ngOnInit() {
    this.wifiData = this.navCtrl.getParam('wifiData', false);
    if (!this.wifiData) {
      const dialogParams = await this.storage.retrieve('dialogParams');
      this.wifiData = dialogParams?.wifiData;
    }
    if (this.wifiData) {
      this.statusIcon = this.wifiService.getStatusIcon(this.wifiData.status);
      this.statusLabel = this.wifiService.getStatusLabel(this.wifiData.status);
      this.formattedLastPing = new Date(this.wifiData.lastPing).toLocaleString();
    }
    this.cdr.markForCheck();
  }

  goBack() {
    this.navCtrl.navigateForward('revenue');
  }
}
